module.exports = __webpack_public_path__ + "img/cr.871fcb6b.svg";